// appsettings.ts
import axios from "axios";

export const baseURL = import.meta.env.VITE_BASE_API_URL;

// Token reference that gets updated by AuthContext
let currentToken: string | null = null;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor using in-memory token reference
axiosInstance.interceptors.request.use(
  (config) => {
    if (currentToken) {
      config.headers.Authorization = `Bearer ${currentToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Function to update the token reference (called by AuthContext)
export const setAuthToken = (token: string | null) => {
  currentToken = token;

  // Also update default headers for immediate effect
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }
};

// Read the current in-memory token (replaces localStorage reads throughout the app)
export const getAuthToken = (): string | null => currentToken;

export default axiosInstance;